let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7hjT7")).then(() => parcelRequire('bQ0Uy'));